import { useState, useEffect } from 'react'
import { Drawer, Grid, IconButton, Paper, Typography } from '@material-ui/core'
import { Close, GroupSharp } from '@material-ui/icons'
import moment from 'moment'

import CollapseList from 'components/commons/CollapsibleList'
import ResultsTable from 'components/ResultsTable'
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'

import { useStyles } from './styles'
import { closeSpinnerAction, openSpinnerAction } from 'context/reducers/openSpinnerReducer'
import { useStateValue } from 'context/store'
import { VALUES } from 'utils/constants'
import { searchAction } from 'actions/SecurityAdminActions'

const GroupsDetails = ({ group, onClose }) => {
   const classes = useStyles()
   const [usersGroup, setUsersGroup] = useState(VALUES.TABLE_DATA_INTIAL_STATE)
   const [searchFilters, setSearchFilters] = useState({})
   const [paginationParams, setPaginationParams] = useState(VALUES.PAGING_ORDER_INITIAL_STATE)
   const { params, setModal, onClose: onCloseModal } = usePortalModal()
   const [_, dispatch] = useStateValue()
   const open = Boolean(group)

   const columns = [
      { title: 'TIPO DE IDENTIFICACIÓN', field: 'documentType', align: 'center' },
      { title: 'NÚMERO DE IDENTIFICACIÓN', field: 'documentNumber', align: 'center' },
      { title: 'USUARIO', field: 'fullName', align: 'center' },
      {
         title: 'FECHA RELACIÓN',
         align: 'center',
         render: rowData => {
            const date = moment(rowData?.relationshipDate)
            return date.isValid() ? date.format('DD/MM/YYYY hh:mm a') : ''
         }
      },
      { title: 'USUARIO RELACIÓN', field: 'relationshipBy', align: 'center' }
   ]

   const closePortalModal = () => {
      setModal({})
   }

   const getGroupsDetails = async (val, pageOptions = VALUES.PAGING_ORDER_INITIAL_STATE) => {
      dispatch(openSpinnerAction())
      try {
         const url = `${process.env.REACT_APP_GROUPS_API}/groups/${group?.id}`
         await searchAction(
            url,
            ['users'],
            () => {},
            setUsersGroup,
            {},
            [searchFilters, setSearchFilters],
            pageOptions,
            [paginationParams, setPaginationParams]
         )
      } catch (error) {
         setModal({
            iconColor: 'error',
            message: (
               <>
                  <Typography variant="h6">Error al cargar los usuarios</Typography>
                  <Typography>Ocurrió un error. Intente nuevamente</Typography>
               </>
            ),
            confirmButtonText: 'Reintentar',
            closeButtonText: 'Cerrar',
            onConfirm: () => {
               closePortalModal()
               getGroupsDetails()
            },
            onClose: () => {
               closePortalModal()
               onClose()
            }
         })
      } finally {
         dispatch(closeSpinnerAction())
      }
   }

   useEffect(() => {
      if (group) getGroupsDetails()
      return () => {
         setUsersGroup([])
      }
   }, [group])

   return (
      <Drawer open={open} onClose={() => onClose()} anchor="right" className={classes.drawer}>
         <Grid container className={classes.container}>
            <Grid container className={classes.header}>
               <Grid container className={classes.title}>
                  <GroupSharp />
                  <Typography variant="h6">Usuarios del grupo</Typography>
               </Grid>
               <IconButton onClick={() => onClose()} aria-label="close" size="small">
                  <Close />
               </IconButton>
            </Grid>
            <Paper className={classes.paper}>
               <Grid container>
                  <Grid container>
                     <Typography className={classes.subtitle}>Información del Grupo</Typography>
                  </Grid>
                  <Grid item xs={12} md={2}>
                     <Typography>ID: {group?.id}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                     <Typography>Nombre: {group?.name}</Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                     <Grid container wrap="nowrap" alignItems="center">
                        <Typography>Roles:</Typography>
                        <CollapseList data={group?.roles} />
                     </Grid>
                  </Grid>
               </Grid>
            </Paper>
            <Paper className={classes.paper}>
               <Grid container>
                  <Typography className={classes.subtitle}>Usuarios</Typography>
               </Grid>
               <Grid item xs={12} className={classes.table}>
                  <ResultsTable
                     columns={columns}
                     tableData={usersGroup}
                     isSearch={true}
                     actionEdit={() => {}}
                     customActions={[]}
                     searchCallback={getGroupsDetails}
                  />
               </Grid>
            </Paper>
         </Grid>
         <PortalModal params={params} onClose={onCloseModal} />
      </Drawer>
   )
}

export default GroupsDetails
